import React from "react";
import { Fab, Paper } from "@material-ui/core/index";
import AssignmentIcon from "@material-ui/icons/Assignment";
import OperatorsListItem from "./OperatorsListItem";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import { insiders } from "../../../mocks";
import paths from "../../../routes/paths";

export default function OperatorsList() {
  const classes = styles();
  const history = useHistory();

  return (
    <Paper className={classes.container} square elevation={0}>
      {insiders.map((item, index) => (
        <OperatorsListItem
          key={index}
          operator={item}
          greyBackground={index % 2 !== 0}
        />
      ))}
      <div>
        <Fab
          color="primary"
          aria-label="add"
          className={classes.fab}
          onClick={() => history.push({ pathname: paths.OPERATOR_ASSIGNMENT })}
        >
          <AssignmentIcon />
        </Fab>
      </div>
    </Paper>
  );
}

const styles = makeStyles(theme =>
  createStyles({
    container: {
      height: "100%",
      paddingBottom: 100,
      overflowY: "scroll"
    },
    fab: {
      margin: 0,
      top: "auto",
      right: 20,
      bottom: 20,
      left: "auto",
      position: "fixed"
    }
  })
);
